import { useEffect, useState } from "react";
import { Container, Row, Col, Alert } from "reactstrap";
import Header, { useHeaderCounts } from "components/Headers/Header.js";
import RevenueByDomainChart from "components/Dashboard/RevenueByDomainChart.js";
import LeadsByTagChart from "components/Dashboard/LeadsByTagChart.js";
import RecentCampaignsTable from "components/Dashboard/RecentCampaignsTable.js";

const API_URL = process.env.REACT_APP_API_URL;

const Index = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const systemCounts = useHeaderCounts();

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_URL}/dashboard/summary`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Falha ao buscar dados do dashboard");
      }

      const data = await response.json();
      setDashboardData(data);
      setError(null);
    } catch (err) {
      console.error("Erro ao buscar dados do dashboard:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();

    // Auto-refresh a cada 5 minutos
    const interval = setInterval(() => {
      fetchDashboardData();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        {error && (
          <Alert color="danger" className="mb-4">
            <strong>Erro:</strong> {error}
          </Alert>
        )}

        {/* Charts Row */}
        <Row>
          <Col xl="6" className="mb-5 mb-xl-0">
            <RevenueByDomainChart data={dashboardData} loading={loading} />
          </Col>
          <Col xl="6">
            <LeadsByTagChart data={dashboardData} loading={loading} />
          </Col>
        </Row>

        {/* Recent Campaigns Table */}
        <Row className="mt-5">
          <Col>
            <RecentCampaignsTable data={dashboardData} loading={loading} />
          </Col>
        </Row>

        {/* System Stats */}
        <Row className="mt-5">
          <Col xl="3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <h5 className="card-title text-uppercase text-muted mb-0">
                      Usuários
                    </h5>
                    <span className="h2 font-weight-bold mb-0">
                      {systemCounts.users}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                      <i className="fas fa-users" />
                    </div>
                  </div>
                </div>
                <p className="mt-3 mb-0 text-muted text-sm">
                  Total de usuários cadastrados
                </p>
              </div>
            </div>
          </Col>
          <Col xl="3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <h5 className="card-title text-uppercase text-muted mb-0">
                      Dispositivos
                    </h5>
                    <span className="h2 font-weight-bold mb-0">
                      {systemCounts.devices}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                      <i className="fas fa-mobile-alt" />
                    </div>
                  </div>
                </div>
                <p className="mt-3 mb-0 text-muted text-sm">
                  Dispositivos cadastrados
                </p>
              </div>
            </div>
          </Col>
          <Col xl="3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <h5 className="card-title text-uppercase text-muted mb-0">
                      Copies
                    </h5>
                    <span className="h2 font-weight-bold mb-0">
                      {systemCounts.copies}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                      <i className="fas fa-copy" />
                    </div>
                  </div>
                </div>
                <p className="mt-3 mb-0 text-muted text-sm">
                  Copies disponíveis no sistema
                </p>
              </div>
            </div>
          </Col>
          <Col xl="3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <h5 className="card-title text-uppercase text-muted mb-0">
                      Bots Ativos
                    </h5>
                    <span className="h2 font-weight-bold mb-0">
                      {systemCounts.bots}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                      <i className="fas fa-robot" />
                    </div>
                  </div>
                </div>
                <p className="mt-3 mb-0 text-muted text-sm">
                  Bots ativos no sistema
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Index;